import styled from "styled-components";
import { toast, ToastContainer } from 'react-toastify';

export const StyledToastContainer = styled(ToastContainer)`
  // https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity
  &&&.Toastify__toast-container {
    display:flex;
    align-items:center;
    justify-content:center;

  }
  .Toastify__toast {

  }
  .Toastify__toast-body {
    font-family:inherit;
    font-weight: 400;
    font-size: 13px;
    text-align: center;
  }
  .Toastify__progress-bar {
  }

  @media (max-width:480px) {

    .Toastify__toast {
        width:80%;
        border-radius:10px;
        margin-bottom:2rem;
    }

    .Toastify__toast-body {
        font-family:inherit;
        font-weight: 400;
        font-size: 13px;
        text-align: center;
    }
  }
  
`;

const defaultToastConfig = {
	autoClose:1500,
	toastId:'toastID1',//Give a different toast id for supporting multiple toasts
	position:"bottom-center",
	hideProgressBar:true,
	closeButton:false,
}

class ToastService { 

    static showToast(message:string, config?:any) {
        toast(message, Object.assign({}, defaultToastConfig, config));
    }

    clearToast() {

    }

    clearAllToast() {

    }
}

export default ToastService;